module.exports = __webpack_public_path__ + "img/pr-8.84fbc687.png";